const getFacebookDetails = async (bot_id) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 1500); // 10 seconds timeout

  // const uri = `${
  //   process.env.REACT_APP_SERVER
  // }int/facebookDetails?bot_id=${encodeURIComponent(bot_id)}`;

  const uri = `${
    process.env.REACT_APP_SERVER
  }/int/facebookDetails?bot_id=${encodeURIComponent(bot_id)}`;

  const option = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    signal: controller.signal,
  };

  try {
    const res = await fetch(uri, option);
    clearTimeout(timeout);

    if (!res.ok) {
      console.error("Failed to fetch integrations");
      return { error: true, data: [] };
    }

    const data = await res.json();

    console.log("facebookData", data);
    return data;
  } catch (error) {
    console.error("Error while fetching integrations:", error);
    return { error: true, data: {} };
  }
};

export default getFacebookDetails;
